const getRandomNumber = (from, to) => Math.floor(Math.random() * (to + 1 - from) + from)

export {
  getRandomNumber
}